import React from 'react';
import css from './ProfileSection.module.css';

const TypingText = ({ word }) => {
  const [displayed, setDisplayed] = React.useState('');
  const [typing, setTyping] = React.useState(true);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    let timeout;
    if (typing) {
      if (index < word.length) {
        timeout = setTimeout(() => {
          setDisplayed(word.slice(0, index + 1));
          setIndex(index + 1);
        }, 120);
      } else {
        timeout = setTimeout(() => setTyping(false), 900);
      }
    } else {
      if (index > 0) {
        timeout = setTimeout(() => {
          setDisplayed(word.slice(0, index - 1));
          setIndex(index - 1);
        }, 120);
      } else {
        timeout = setTimeout(() => setTyping(true), 400);
      }
    }
    return () => clearTimeout(timeout);
  }, [typing, index, word]);

  return (
    <span>
      {displayed}
      <span className={css.caret}></span>
    </span>
  );
};

const ProfileSection = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.boxes}>
        <div className={css.textBox}>
          <p className={css.textBoxTitle}>
            Become a creator.
            <br />
            <TypingText word={'Its so easy!'} />
          </p>

          <p className={css.textBoxDescription}>
            Sell your 3d scans, build your brand, and earn from the work you love—right here on
            ScanWow.
          </p>
          <p className={css.textBoxPrint}>Got scans? Let's go…</p>
          <a className={css.createButton} href="/profile-settings">
            <span>Create Your Profile</span>
          </a>
        </div>
        <div className={css.greenBox}>
          <p className={css.greenBoxTitle}>Upload your scans</p>
          <p className={css.greenBoxDescription}>
            Drag, drop, and list your work. Don't forget to add some tags!
          </p>
        </div>
        <div className={css.whiteBox}>
          <p className={css.whiteBoxTitle}>Set your terms</p>
          <p className={css.whiteBoxDescription}>
            Choose your licence. Set your price. Decide what gets shared and how in just a few
            clicks.
          </p>
        </div>
        <div className={css.yellowBox}>
          <p className={css.yellowBoxTitle}>Earn on your own terms</p>
          <p className={css.yellowBoxDescription}>
            Make passive income from your archive—or launch something new. Use our site to showcase
            your work.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileSection;
